<template>
  <div class="section">
    <div class="box">
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-warning" @click="getDataExport()">Download</button>
        </div>
      </div>
      <table class="table is-fullwidth">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Gender</th>
          <th>Job</th>
          <th>DATE Group</th>
          <th>Division</th>
          <th>Register Date</th>
        </tr>
        <tr v-for="(new_member_row, index) in new_member_list" :key="index">
          <td v-text="new_member_row.name"></td>
          <td v-text="new_member_row.email"></td>
          <td v-text="new_member_row.phone"></td>
          <td v-text="new_member_row.gender"></td>
          <td v-text="new_member_row.job"></td>
          <td v-text="new_member_row.date"></td>
          <td v-text="new_member_row.division"></td>
          <td v-text="new_member_row.register_date"></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      new_member_list: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getNewMemberList()
  },
  methods: {
    getNewMemberList () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/new_member')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.new_member_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getDataExport () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/new_member/export_member')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          let link = document.createElement('a')
          link.href = response.data.data.file_url
          link.download = response.data.data.file_name
          link.click()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        console.log(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/new_member/Home.vue